import { devtools } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

/**
 * 개발자용 오버레이 토글 스토어 (VPF-5264).
 * 브라우저 콘솔의 `__dev__` 명령(`$app/devCommand`)으로만 바꾸며 UI 노출은 없습니다.
 * 오버레이 collect 는 매 프레임 `getState()` 로 읽으므로 구독하지 않습니다.
 */
type DevOverlayState = {
  /** VObject 툴팁 아래에 서버가 준 inZoneInfo 원본값을 표시합니다 */
  vObjectOverlay: boolean;
};

type DevOverlayAction = {
  clear: () => void;
  /** 인자가 없으면 반전하고, boolean 을 주면 그 값으로 맞춘 뒤 바뀐 값을 돌려줍니다 */
  toggleVObjectOverlay: (enabled?: boolean) => boolean;
};

const INIT_STATE: DevOverlayState = {
  vObjectOverlay: false,
};

export const useDevOverlayStore = createWithEqualityFn<
  DevOverlayAction & DevOverlayState
>()(
  devtools(
    (set, get) => ({
      ...INIT_STATE,

      clear: () => set({ ...INIT_STATE }),

      toggleVObjectOverlay: enabled => {
        const vObjectOverlay = enabled ?? !get().vObjectOverlay;
        set({ vObjectOverlay });

        return vObjectOverlay;
      },
    }),
    { name: 'devOverlayStore' },
  ),
  shallow,
);
